<template>
  <div>
    <div class="emd-tabbar jsTabbar _bordered _bordered">
      <ul class="emd-tabbar__list">
        <li class="emd-tabbar__item">
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('info')"
            v-bind:class="{ _active: tabActive === 'info' }"
          >
            <span class="emd-text">{{ $t('webhook.detail.tab-info') }}</span>
          </a>
        </li>
        <li class="emd-tabbar__item">
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('request')"
            v-bind:class="{ _active: tabActive === 'request' }"
          >
            <span class="emd-text">{{ $t('webhook.detail.tab-request') }}</span>
          </a>
        </li>
        <li class="emd-tabbar__item">
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('response')"
            v-bind:class="{ _active: tabActive === 'response' }"
          >
            <span class="emd-text">{{
              $t('webhook.detail.tab-response')
            }}</span>
          </a>
        </li>
      </ul>
    </div>
    <webhook-info v-if="tabActive === 'info'"></webhook-info>
    <webhook-request v-if="tabActive === 'request'"></webhook-request>
    <webhook-response v-if="tabActive === 'response'"></webhook-response>

    <last-log></last-log>
  </div>
</template>
<script>
import WebhookInfo from '@/views/Webhooks/WebhooksDetail/WebhookInfo.vue'
import WebhookRequest from '@/views/Webhooks/WebhooksDetail/WebhookRequest.vue'
import WebhookResponse from '@/views/Webhooks/WebhooksDetail/WebhookResponse.vue'
import LastLog from '@/components/project/molecules/LastLog.vue'
export default {
  name: 'WebhooksDetail',
  components: {
    WebhookInfo,
    WebhookRequest,
    WebhookResponse,
    LastLog
  },
  data () {
    return {
      tabActive: 'info'
    }
  },
  computed: {
    params () {
      return {
        merchantId: this.$store.getters.merchantId,
        accountId: this.$store.getters.accountId,
        entityId: this.$route.params.id,
        refresh: true
      }
    }
  },
  methods: {
    changeTab (tab) {
      this.tabActive = tab
      this.$router
        .push({ name: 'webhooksDetail', params: { tab: tab } })
        .catch(err => err)
    }
  },
  beforeMount () {
    this.tabActive = this.$route.params.tab
  },
  created () {
    this.$store.dispatch('GET_LAST_LOG', this.params)
  },
  mounted () {
    if (!this.$route.params.id.includes('hook_')) {
      this.$router.push({ name: 'webhooks' }).catch(err => err)
    }
  }
}
</script>
